import React from "react";
import { FUXA_VIEW_URL } from "../constant";

/**
 * "Схема" как виджет на канвасе.
 *
 * Диплинк на конкретный View подтверждён рабочим примером:
 * https://<fuxa-host>/view?name=<viewName>
 *
 * config.fuxaView должен быть проставлен на unit (см. UnitForm.jsx, поле
 * "View в FUXA" — селект, заполняемый через прокси GET /fuxa/views).
 *
 * Если у юнита ещё не выбран fuxaView — не показываем общую мнемосхему
 * молча (это будет вводить в заблуждение, будто это и есть схема юнита),
 * а явно говорим, что виджет не настроен.
 */
function UnitSchemeWidget({ unitId, unit }) {
	const fuxaView = unit?.fuxaView;

	if (!FUXA_VIEW_URL) {
		return (
			<div style={{ padding: 16, color: "#868e96" }}>
				FUXA_URL не сконфигурирован (REACT_APP_FUXA_URL).
			</div>
		);
	}

	if (!fuxaView) {
		return (
			<div style={{ padding: 16, color: "#868e96" }}>
				Для этого юнита не выбран View в FUXA. Откройте юнит на
				редактирование и укажите View.
			</div>
		);
	}

	const src = `${FUXA_VIEW_URL}?name=${encodeURIComponent(fuxaView)}`;

	return (
		<div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
			<iframe
				src={src}
				style={{
					width: "100%",
					height: "100%",
					border: "none",
					display: "block",
				}}
				title={`FUXA Schema — unit ${unitId} (${fuxaView})`}
			/>
		</div>
	);
}

export default UnitSchemeWidget;
